var path = 'services/info-toast.tpl.html';
var html = "\n<md-toast class=\"tb-info-toast\">\n    <div class=\"md-toast-content\">\n        <div class=\"md-toast-text\" ng-bind-html=\"vm.message\"></div>\n        <md-button class=\"md-action md-highlight md-accent\" ng-click=\"vm.closeToast()\">\n            {{ 'action.close' | translate }}\n        </md-button>\n    </div>\n</md-toast>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/services/info-toast.tpl.html
// module id = 1521
// module chunks = 1